import React from 'react'
import PropTypes from 'prop-types'
import { DomUtil, Map } from 'leaflet'

class MapClickEventHandler extends React.Component {
    static contextTypes = {
        map: PropTypes.instanceOf(Map)
    }
    constructor() {
        super()
        this.mapClicked = this.mapClicked.bind(this)
        this.mapMouseMove = this.mapMouseMove.bind(this)
        this.mapMouseOut = this.mapMouseOut.bind(this, null)
    }

    mapClicked(e) {
        if (this.props.onClick && !e.originalEvent.cancelBubble) {
            this.props.onClick([e.latlng.lat, e.latlng.lng])
        }
    }

    mapMouseMove(e) {
        if (this.props.onMouseMove && !e.originalEvent.cancelBubble) {
            this.props.onMouseMove([e.latlng.lat, e.latlng.lng])
        }
    }

    mapMouseOut() {
        if (this.props.onMouseMove) {
            this.props.onMouseMove(null)
        }
    }

    componentDidMount() {
        if (this.context.map) {
            this.context.map.on('click', this.mapClicked)
            this.context.map.on('mousemove', this.mapMouseMove)
            this.context.map.on('mouseout', this.mapMouseOut)
            DomUtil.addClass(this.context.map._container, 'polygon-selection-active')
        }
    }

    componentWillUnmount() {
        if (this.context.map) {
            this.context.map.off('click', this.mapClicked)
            this.context.map.off('mousemove', this.mapMouseMove)
            this.context.map.off('mouseout', this.mapMouseOut)
            DomUtil.removeClass(this.context.map._container, 'polygon-selection-active')
        }
    }

    render() {
        return null
    }
}

export default MapClickEventHandler



// WEBPACK FOOTER //
// ./src/felles/Kart/MapClickEventHandler.jsx